import crossFetch from 'cross-fetch';

/**
 * A wrapper around fetch that includes the auth token in the headers.
 * Use fetch for API requests that do not require a auth/token.
 *
 * @param { RequestInfo | URL } uri The URI to fetch.
 * @param { RequestInit } init The request init object.
 * @returns { Promise<Response> } The response from the fetch.
 */
async function fetchWithToken(uri: RequestInfo | URL, init: RequestInit = {}) {
  return crossFetch(uri, {
    ...init,
    headers: {
      ...init.headers,
    },
    credentials: 'include', // Need this to send the JWT token via cookies to the server.
  });
}

export { fetchWithToken, crossFetch as fetch };
